/**
 * /auth/callback route. The Lambda at /api/v1/core/auth/callback handles the
 * actual OIDC exchange and 302-redirects before the SPA loads. This page is
 * a safety net for the case where the redirect arrives at the SPA before the
 * cookie is set, or if someone hits the route manually.
 */
export function SigningIn() {
  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-amp-700">
      Signing you in...
    </div>
  );
}
